import "../../Style/actionstyle.scss";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { DELETE_REASON_OF_LOSS_MEMBER } from "../../Schema/ReasonOfLossMember"; 
import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import DialogDelete from "../../Utils/DialogDelete";
import ReasonOfLossMemberForm from "./ReasonOfLossMemberForm";

export default function ReasonOfLossMemberAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  //Modal update 
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [deleteReasonOfLossMember] = useMutation(DELETE_REASON_OF_LOSS_MEMBER, {
    onCompleted: ({ deleteReasonOfLossMember }) => {
      setLoading(false);
      if (deleteReasonOfLossMember?.isSuccess === true) {
        setAlert(true, "success", deleteReasonOfLossMember?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteReasonOfLossMember?.message);
      }
    }, 
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteReasonOfLossMember({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openEdit && (
        <ReasonOfLossMemberForm
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_reason_of_loss_member")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
